<div [formGroup]="group">
    <h2 *ngIf="config.title">{{ config.title }}</h2>
        
    <text-field [group]="group" placeholder="code" controlName="code"></text-field>
    <text-field [group]="group" placeholder="name" controlName="name"></text-field>
    <text-field [group]="group" placeholder="telephone" controlName="telephone"></text-field>
</div>